import { render, staticRenderFns } from "./UpdateUserVendorForm.vue?vue&type=template&id=74b0e3e8&scoped=true&"
import script from "./UpdateUserVendorForm.vue?vue&type=script&lang=js&"
export * from "./UpdateUserVendorForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserVendorForm.vue?vue&type=style&index=0&id=74b0e3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0e3e8",
  null
  
)

export default component.exports